export const API_BASE = import.meta.env.DEV
  ? 'http://localhost:8080/api'
  : '/api';
